import { Candidates, RepublicanDelegateCount, DemocraticDelegateCount } from './constants';
/*eslint-disable no-alert, no-console */

function wrangleData(data) {
  var highScore = { democrats: {}, republicans: {} };
  Candidates.democrats.forEach(function(d) { highScore.democrats[d] = 0; });
  Candidates.republicans.forEach(function(d) { highScore.republicans[d] = 0; });

  var democraticDelegateSum = 0;
  var republicanDelegateSum = 0;

  data.forEach(function(d,i) {
    // Is it the first election on that day
    if (data[i-1]) {
      d['firstForDate'] = d['date'] !== data[i-1]['date'] ? true : false;
    } else {
      d['firstForDate'] = true;
    }

    // Place results in separate arrays
    d.results = {democrats: [], republicans: []};

    Candidates.democrats.forEach(function(c) {
      d.results.democrats.push({ name: c, delegates: +d[c] });
      highScore.democrats[c] += parseInt(d[c] || 0);
      democraticDelegateSum += parseInt(d[c] || 0);
      delete d[c];
    });

    Candidates.republicans.forEach(function(c) {
      d.results.republicans.push({ name: c, delegates: +d[c] });
      highScore.republicans[c] += parseInt(d[c] || 0);
      republicanDelegateSum += parseInt(d[c] || 0);
      delete d[c];
    });

    // Sort the results array
    d.results.democrats.sort(function(a, b) {
      if (d.winner_d && d.winner_d === a['name']) {
        return -1;
      }
      if (d.winner_d && d.winner_d === b['name']) {
        return 1;
      }
      return b['delegates'] - a['delegates'];
    });

    d.results.republicans.sort(function(a, b) {
      if (d.winner_r && d.winner_r === a['name']) {
        return -1;
      }
      if (d.winner_r && d.winner_r === b['name']) {
        return 1;
      }
      return b['delegates'] - a['delegates'];
    });
  });

  const democrats = Object.keys(highScore.democrats);
  const republicans = Object.keys(highScore.republicans);
  var democratsArr = [], republicansArr = [];

  democrats.forEach(function(d) {
    var share = Number((highScore.democrats[d] / DemocraticDelegateCount * 100).toFixed(2));
    democratsArr.push({ name: d, delegates: highScore.democrats[d], delegateShare: share });
  });
  democratsArr.sort(function(a, b) { return b.delegates - a.delegates; });

  republicans.forEach(function(d) {
    var share = Number((highScore.republicans[d] / RepublicanDelegateCount * 100).toFixed(2));
    republicansArr.push({ name: d, delegates: highScore.republicans[d], delegateShare: share });
  });
  republicansArr.sort(function(a, b) { return b.delegates - a.delegates; });

  data.highScore = {republicans: republicansArr, democrats: democratsArr};
  data.delegateSum = {republicans: republicanDelegateSum, democrats: democraticDelegateSum};
  return data;
}

export default wrangleData;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/helpers/datawrangler.js
 **/